import type { DefaultOptions } from "@tanstack/react-query";
import { HOURS } from "@warrenio/utils/timeUnits";

/** Query options for long-running queries that should not be re-fetched often */
export const intensiveQueryOptions = {
    staleTime: 12 * HOURS,
} satisfies DefaultOptions["queries"];
